import dynamic from 'next/dynamic';
import { PlannerEventListProps } from './PlannerEventList.types';

export const PlannerEventList = dynamic<{ model: PlannerEventListProps }>(() =>
  import('./PlannerEventList').then(mod => mod.PlannerEventList)
);
